import React, { useEffect, useState } from 'react';
import {
    Alert,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from '@mui/material';

/**
 * A decision that needs only a written reason (revoke a link, close a release as not identifiable)
 * @param {function} onSubmit (note) => Promise
 */
export default function NoteDialog({
    open,
    title,
    label,
    info,
    min = 5,
    action,
    onSubmit,
    onClose,
}) {
    const [note, setNote] = useState('');
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        if (open) setNote('');
    }, [open]);
    const valid = note.trim().length >= min;
    const submit = () => {
        if (!valid || saving) return;
        setSaving(true);
        onSubmit(note.trim()).finally(() => setSaving(false));
    };
    return (
        <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth="sm">
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {info && (
                    <Alert severity="info" sx={{ mb: 2 }}>
                        {info}
                    </Alert>
                )}
                <TextField
                    autoFocus
                    fullWidth
                    multiline
                    minRows={2}
                    label={label}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    helperText={`Kötelező, legalább ${min} karakter`}
                />
            </DialogContent>
            <DialogActions>
                {saving && <CircularProgress size={20} sx={{ mr: 1 }} />}
                <Button onClick={onClose} disabled={saving}>
                    Mégse
                </Button>
                <Button variant="contained" onClick={submit} disabled={!valid || saving}>
                    {action}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
